/* eslint-disable react-hooks/immutability */
import { Coordinates, ImageSource } from "maplibre-gl";
import { useEffect } from "react";
import { useMap } from "react-map-gl/maplibre";
import { useHeightData, useIsSection } from "../../state";

export const transparentPng =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==";
export const fake: Coordinates = [
  [0, 0],
  [1, 0],
  [1, 1],
  [0, 1],
];

export const ImageOverlayControl = ({ id }) => {
  const map = useMap().current?.getMap();
  const data = useHeightData((s) => s.data);
  const visible = useIsSection("soil");
  const source = map?.getSource(id) as ImageSource;

  useEffect(() => {
    if (!(map && source)) return;
    const visibility = data?.url && visible ? "visible" : "none";
    if (data?.url && source.url !== data?.url) {
      const { url, extent } = data;
      const [left, bottom, right, top] = extent;
      // The coordinates start at the top left corner of the image and proceed in clockwise order. They do not have to represent a rectangle.
      const coordinates: Coordinates = [
        [left, top],
        [right, top],
        [right, bottom],
        [left, bottom],
      ];
      source.updateImage({ url, coordinates });
    } else {
      // @ts-ignore
      if (!data?.url && source.image !== transparentPng) {
        // force sync setting of empty image. loadImage() does it async with glitches
        // @ts-ignore
        source.image = transparentPng;
        source.coordinates = fake;
        source._finishLoading();
      }
    }

    if (map.getLayer(id) && map.getLayoutProperty(id, "visibility") !== visibility) {
      map.setLayoutProperty(id, "visibility", visibility);
    }
  }, [map, data, source, id, visible]);
  return null;
};
